module.exports = __webpack_public_path__ + "img/Ford-Ranger-2.34e6a991.png";